import { CommonModule }         from '@angular/common';
import { NgModule }             from '@angular/core';
import { NgbDropdownModule }    from '@ng-bootstrap/ng-bootstrap';
import { SvgModule }            from '@shared/components/svg/svg.module';
import { MonthPickerComponent } from './month-picker.component';


@NgModule( {
	declarations: [ MonthPickerComponent ],
	imports: [
		// Angular
		CommonModule,

		// Shared
		NgbDropdownModule,

		// App
		SvgModule
	],
	exports: [ MonthPickerComponent ]
} )
export class MonthPickerModule {}
